import React, { memo } from 'react';
import { FilterSelect } from '@global-ecom/nitro-uds/elements';
import Head from 'next/head';

import { useTranslate } from 'hooks/useTranslations';
import { SortOption } from '__generated__/graphql';
import { useProductListFilterContext } from 'ui/components/ProductListFilterProvider';
import { useSiteConfig } from 'hooks/useSiteConfig';
import { AnalyticsEvents, event } from 'utils/analytics';
import { usePageEventsContext } from 'hooks/usePageEventsContext';
import { isNotNullish } from 'utils/isNotNullish';

const MemoComponent: React.FC<{
  options: SortOption[];
  defaultSortOption: string;
}> = ({ options, defaultSortOption }) => {
  const t = useTranslate();

  const { plpShowDefaultSortOption } = useSiteConfig();
  const { pageviewEventHasFired } = usePageEventsContext();
  const { queryParams, dispatchAnalyticsEvent, setSortOrder } =
    useProductListFilterContext();

  const handleSortChange = value => {
    dispatchAnalyticsEvent({
      event: AnalyticsEvents.SORT_SELECTED,
      params: {
        domevent: value,
        domlabel: ``,
      },
    });
    if (pageviewEventHasFired) {
      event(AnalyticsEvents.GA4_CustomEvent, {
        event_name: 'sort',
        event_params: { sort_selected: value },
      });
    }

    setSortOrder(value);
  };

  const hasSortParam = isNotNullish(queryParams.sort);

  return (
    <>
      {hasSortParam && (
        <Head>
          <meta name="robots" content="noindex, follow" />
        </Head>
      )}
      <FilterSelect
        key={queryParams.sort || 'default'}
        label={t('sortBy')}
        className="uppercase"
        dataTestId="product-list-sort-select"
        id="product-list-sort-select"
        placeholder={t('sortBy')}
        defaultValue={
          queryParams.sort ||
          (plpShowDefaultSortOption && defaultSortOption) ||
          ''
        }
        name="sortBy"
        onChange={handleSortChange}
        options={(options || []).map(option => ({
          label: option.label,
          value: option.id,
        }))}
      />
    </>
  );
};

export const ProductListSort = memo(MemoComponent);
